import { HomePage } from './pages/Home.page'

import type { RouteObject } from 'react-router-dom'

const homeRoutes: RouteObject[] = [
  {
    index: true,
    element: <HomePage />,
  },
  {
    path: 'home',
    element: <HomePage />,
  },
]

export { homeRoutes }
